/**
 * Mock Utils
 * This file contains mock data for development purposes.
 * It is used to generate mock data for the familyMock in the brothers-attribution module, and others in the future.
 */

export const mockUtils = {
  hebFirstNames: [
    "ודים",
    "זוהר",
    "סמי",
    "רוי",
    "זכריה",
    "שון",
    "ניצן",
    "רואי",
    "מסעוד",
    "שילה",
    "איסק",
    "יוחאי",
    "אלימלך",
    "אליאור",
    "אמיל",
    "יחיא",
    "ליאל",
    "שליו",
    "מוטי",
    "ליאב",
    "נמרוד",
    "טוביה",
    "יוסף יצחק",
    "גולן",
    "עקיבא",
    "רחל",
    "שרה",
    "אסתר",
    "מרים",
    "דניאל",
    "חנה",
    "רבקה",
    "יעל",
    "מיכל",
    "לאה",
    "אורי",
    "תמר",
    "עומר",
    "עדי",
    "נועה",
    "שושנה",
    "יובל",
    "עמית",
    "רות",
    "טל",
    "אריאל",
    "ליאור",
    "אנה",
    "שירה",
    "מאיה",
    "יהודית",
    "נועם",
    "אלה",
    "ילנה",
    "מלכה",
    "רוני",
    "שי",
    "גיא",
    "אירינה",
    "עדן",
    "חיה",
    "אור",
    "הילה",
    "מריה",
    "שחר",
    "טטיאנה",
  ],
  usersWithUserNamesAndEmails: [
    {
      firstName: "אביגיל",
      lastName: "כהן",
      userName: "abigailk",
      email: "abiygale-cohen",
    },
    {
      firstName: "אבישי",
      lastName: "לוי",
      userName: "avishail",
      email: "avShalom1235",
    },
    {
      firstName: "שרית",
      lastName: "מזרחי",
      userName: "sharit",
      email: "sharitMizrachi",
    },
    {
      firstName: "ליאור",
      lastName: "פרץ",
      userName: "liorP",
      email: "" + "liorPertz",
    },
    {
      firstName: "רוני",
      lastName: "ביטון",
      userName: "roniB",
      email: "roniBiton",
    },
    {
      firstName: "דולב",
      lastName: "פרידמן",
      userName: "dolevF",
      email: "dolevFriedman",
    },
    {
      firstName: "רוחמה",
      lastName: "אברהם",
      userName: "ruhmaA",
      email: "ruhmaAvraham",
    },
    {
      firstName: "מוחמד",
      lastName: "דהמשה",
      userName: "mohamadD",
      email: "mohamadDehane",
    },
    {
      firstName: "דורי",
      lastName: "כץ",
      userName: "doriK",
      email: "doriKatz",
    },
    {
      firstName: "יפתח",
      lastName: "אזולאי",
      userName: "yiftahA",
      email: "yiftahAzulai",
    },
    {
      firstName: "קרן",
      lastName: "מלכה",
      userName: "karenM",
      email: "karenMalka",
    },
    {
      firstName: "יוסי",
      lastName: "דוד",
      userName: "yossiD",
      email: "yossiDavid",
    },
    {
      firstName: "רוויטל",
      lastName: "חדד",
      userName: "revitalH",
      email: "revitalHaddad",
    },
    {
      firstName: "נטע",
      lastName: "עמר",
      userName: "netaO",
      email: "netaOmer",
    },
    {
      firstName: "שמעון",
      lastName: "אוחיון",
      userName: "shimonO",
      email: "shimonOchion",
    },
    {
      firstName: "מירי",
      lastName: "ששון",
      userName: "miriS",
      email: "miriShashon",
    },
    {
      firstName: "חן",
      lastName: "יהוסף",
      userName: "chenY",
      email: "chenYosef",
    },
    {
      firstName: "יעל",
      lastName: "קליין",
      userName: "yaelK",
      email: "yaelKlein",
    },
  ],
  eventNames: [
    " טיול אביב ארצי",
    "טיול חנוכה",
    "הפגנה",
    "רפסודיה",
    "טיול ים אל ים",
    "מיסי קן",
    "כותרת הרבה יותר ארוכה",
    "חולצת תנועה XL",
    "חולצת תנועה M",
    "פורימון",
    "מחנה פילים",
    "מחנה ד-ו",
    "מרתון",
    "עבודה בקטיף ברביד",
    "שיחה עם פסח",
    "נסיעה לירושליים",
  ],

  hebLastNames: [
    "כהן",
    "לוי",
    "מזרחי",
    "פרץ",
    "ביטון",
    "פרידמן",
    "אברהם",
    "דהן",
    "כץ",
    "אזולאי",
    "מלכה",
    "דוד",
    "חדד",
    "עמר",
    "אוחיון",
    "גבאי",
    "יהוסף",
    "קליין",
    "לוין",
    "שפירא",
    "בן דוד",
    "סגל",
    "אדרי",
    "אשכנזי",
    "משה",
    "חזן",
    "שורץ",
    "טל",
    "רוזנברג",
    "חן",
    "גולדברג",
    "גולדשטיין",
    "גלבוע",
    "הרוש",
    "בנימין",
    "ברגר",
    "שמואל",
    "אדלר",
    "פרנקל",
    "צרפתי",
    "חיון",
    "דוידוב",
    "שכטר",
    "נגר",
    "ליבוביץ",
    "מלול",
    "רוזנפלד",
    "אורן",
    "יהודה",
    "ליפשיץ",
    "בן שושן",
    "פוקס",
    "אסרף",
    "גל",
    "גולדמן",
    "ברק",
    "אהרן",
    "רוט",
  ],
  citiesAndNests: [
    "קריית טבעון",
    "טמרת",
    "יובלים",
    "ראשון לציון",
    "גבעת אלה",
    "שהם",
    "קריית מלאכי",
    "חולון",
    "רחובות",
    "גשר הזיו",
    "קריית חיים",
    "קריית ים",
    "קריית שמונה",
    "קריית יערים",
    "קריית אונו",
    "קריית ביאליק",
  ],
  createIntRandomIntInRange: (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
  },
};



// WEBPACK FOOTER //
// ./src/app/development/mocks/mock-utils.ts